import React from 'react'
import R from 'ramda'

import Poi from './Poi'
import PoiEntry from './PoiEntry'

const NearTo = ({query, zoom, viewPort, map, address, searchingPoi, poiOptions, onSearch, onAdd, onChange, onDelete, onToggle, onToggleEditFrequency, onSelect, options}) => {
  const poiEntryProps = {
    address,
    searchingPoi,
    poiOptions,
    onSearch,
    onAdd,
  }
  const poisElements = R.addIndex(R.map)((poi, index) => {
    const poiProps = {
      options,
      onChange,
      onDelete,
      onToggle,
      onToggleEditFrequency,
      index,
      poi,
      zoom, 
      viewPort, 
      map,
      onSelect
    }
    
    return <Poi {...poiProps} key={index}/>
  }, query.pois)

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: "100%",
    marginTop: "-10px"
  }

  return <div style={containerStyle}>
    {poisElements}
    <PoiEntry {...poiEntryProps}/>
  </div>
}

NearTo.propTypes = {
  address: React.PropTypes.string.isRequired,
  searchingPoi: React.PropTypes.bool.isRequired,
  poiOptions: React.PropTypes.array.isRequired,
  onAdd: React.PropTypes.func.isRequired,
  onDelete: React.PropTypes.func.isRequired,
  onToggle: React.PropTypes.func.isRequired,
  onChange: React.PropTypes.func.isRequired,
  onSearch: React.PropTypes.func.isRequired,
  onToggleEditFrequency: React.PropTypes.func.isRequired,
  query: React.PropTypes.shape({
    pois: React.PropTypes.array.isRequired,
  }),
  options: React.PropTypes.shape({
    transportationTypes: React.PropTypes.array.isRequired,
    travelDurations: React.PropTypes.array.isRequired
  }),
}


export default NearTo



/** WEBPACK FOOTER **
 ** ./app/components/NearTo.jsx
 **/